export const CAMPAIGN_SELECTION_MODES = Object.freeze({
  ALL: 'All',
  SPECIFIC: 'Specific',
});
